<app-bread-crumb [items]="[{text:  'notícia',link:'/admin/news'},{text:'detalhe'}]"
  [sectionTitle]="'Detalhe da Notícia'">
</app-bread-crumb>

<!-- <hr style="border-color:white"> -->


<section class="content">

<div class="row">
    <div class="col-md-10 col-md-offset-1">
        <!-- Box Comment -->
        <div class="box box-widget">
          <div class="box-header with-border">
            <div class="user-block">

              <img class="img-circle" [src]="news?.user?.picture || 'https://imalimoz.herokuapp.com/users/avatar/Default-avatar.jpg'" alt="User Image">
              <span class="pull-right text-danger">Clube: <strong [ngStyle]="{color: news?.club?.color}">{{news?.club?.name}}</strong></span>
              <span class="username"><a href="#">{{news?.user?.name}}.</a></span>
              <span class="description">Publicado em - {{news?.createdAt}}</span>

            </div>
          </div>

          <!-- /.box-header -->
          <div class="box-body">
            <div class="row">

                <div class="col-md-12">
                     <h2 class="text-center" style="color:#f35309;font-weight: 500;"><i class="fa fa-quote-left"></i> {{ news?.title }} <i class="fa fa-quote-right"></i></h2>
                     <img class="img-responsive pad" [src]="news?.photo" alt="Product Image">
                </div>


                <div class="col-md-12">

                    <div [innerHtml]="news?.description"></div>


                    <button type="button" class="pull-right btn btn-outline-danger btn-md" (click)="editNews()"><i class="fa fa-edit"></i> Editar</button>
                    <span class="text-muted">{{news?.comments?.length}} - comentários</span> 
                </div>

            </div>

          </div>
          <!-- /.box-body -->

          <div class="box-footer box-comments">

            <div class="box-comment" *ngFor="let comment of news?.comments">
              <!-- User image -->
              <img class="img-circle img-sm" [src]="comment?.member?.photo || 'https://localhost:4200/assets/khuzela.png'" alt="User Image">

              <div class="comment-text">
                    <span class="username">
                      {{comment?.member?.name}}
                      <span class="text-muted pull-right" >{{comment.created_at}}</span>
                    </span><!-- /.username -->
                {{comment.comment}}
              </div>
              <!-- /.comment-text -->
            </div>
            <!-- /.box-comment -->

          </div>


        </div>
        <!-- /.box -->
      </div>
      <!-- /.col -->
</div>
</section>